var styles = {
  "Button": "_Button_q0eij_34",
  "pressed": "_pressed_q0eij_84",
  "icon": "_icon_q0eij_96",
  "bordered": "_bordered_q0eij_101",
  "disabled": "_disabled_q0eij_119",
  "Disclosure": "_Disclosure_q0eij_137"
};

export { styles as default };
